/**
 * CSS Grid의 grid-area 이름을 유효한 CSS 식별자로 변환합니다.
 * 
 * @param status - 변환할 상태 값 (보통 Board ID)
 * @returns CSS 유효한 grid-area 이름
 * 
 * @example
 * sanitizeGridAreaName('36SUy1IlNBAgASslOJlV') // → 'area-36suy1ilnbagasslojlv'
 * sanitizeGridAreaName('empty') // → '.'
 * sanitizeGridAreaName('board@timeline#123') // → 'area-boardtimeline123'
 */
export const sanitizeGridAreaName = (status: string): string => {
  if (status === 'empty' || status === '.') {
    return '.'; // 빈 공간은 점으로 유지
  }

  // CSS 유효한 이름으로 변환:
  // 1. 특수문자 제거: /[^a-zA-Z0-9]/g
  // 2. 소문자 변환: .toLowerCase()  
  // 3. 접두사 추가: area-
  return `area-${status.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`;
}; 